const laPlagne = 4
const lesArcs = 3
const lesMenuires = 10027
const valThornes = 23
const tignes = 110033
const lesDeuxAlpes = 110032
const risoul = 8
const valCenis = 10023
const valfrejus = 47
const laToussuire = 49
const saitJeadDarves = 50
const leCorbier = 51
const saitSorlinDarves = 53
const lesOrres = 66
const laRosiere = 151
const valmeinier = 30
const valDisere = 110036
const courchevel = 5
const meribel = 110031

const defaultTopStationsConfig: { [key: string]: number[] } = {
    fr_FR: [laPlagne, lesArcs, lesMenuires, valThornes, tignes, lesDeuxAlpes, risoul, laToussuire, valCenis, valfrejus],
    en_US: [valThornes, laPlagne, lesArcs, laRosiere, tignes, valDisere, courchevel, lesMenuires, meribel, lesDeuxAlpes],
    nl_NL: [valThornes, laPlagne, lesArcs, valCenis, lesMenuires, saitJeadDarves, laToussuire, valmeinier, tignes, lesOrres],
    fr_FR_CSE: [laPlagne, lesArcs, lesMenuires, valThornes, tignes, lesDeuxAlpes, risoul, laToussuire, valCenis, valfrejus]
}

export default defaultTopStationsConfig
